import React, { FC } from 'react'
import { useHistory } from 'react-router-dom'
import { Grid, Typography, makeStyles, Theme } from '@material-ui/core'

import { PillButton } from 'components'
import WelcomeBG from 'assets/welcome-header.png'
import { EventStages } from '../../types'

interface MobileWelcomeProps {
  eventStage?: EventStages
}

export const MobileWelcome: FC<MobileWelcomeProps> = ({ eventStage }) => {
  const history = useHistory()
  const classes = useStyles()

  const watchLiveStream = () => {
    if (eventStage !== EventStages.POSTEVENT) {
      history.push(`/stream`)
    } else {
      history.push(`/event/event-replay/fullShow`)
    }
  }

  return (
    <div className={classes.root}>
      <Grid container>
        <Grid item xs={12}>
          <img className={classes.image} src={WelcomeBG} alt='Verizon 5G Logo' />
        </Grid>
        <Grid container item xs={12} className={classes.contentContainer}>
          <Grid item xs={12}>
            <Typography variant='h1' className={classes.heading}>
              Welcome to 5G Innovation Sessions: Advancing the Mission of the DOD
            </Typography>

            <Typography paragraph>
              Defense agencies are looking for ways to become more agile with 5G in an effort to enhance their digital
              transformation initiatives and better support the warfighter.
            </Typography>

            <Typography paragraph>
              During this hour-long event, Verizon will explain why 5G matters to the DOD, how it can help securely
              shape missions, and discuss defense-focused use cases.
            </Typography>

            <Typography paragraph>
              Additionally, we discuss the path one military base took to deploy 5G and how it is being used to support
              their strategic initiatives.
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <PillButton onClick={watchLiveStream}>
              {eventStage !== EventStages.POSTEVENT ? 'Watch live stream' : 'Watch event replay'}
            </PillButton>
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1
  },
  image: {
    width: '100%'
  },
  heading: {
    marginBottom: '1rem'
  },
  contentContainer: {
    padding: '2rem'
  }
}))
